import Vue from 'vue';
import { concat, filter, map } from 'lodash';
import types from './mutation-types';

const mutations = {
  [types.FETCH_MY_QUIZZES_REQUEST](state) {
    Vue.set(state, 'isLoadingMyQuizzes', true);
  },

  [types.FETCH_MY_QUIZZES_SUCCESS](state, { myQuizzes, total }) {
    Vue.set(state, 'isLoadingMyQuizzes', false);
    Vue.set(state, 'total', total);
    Vue.set(state, 'myQuizzes', myQuizzes);
  },

  [types.FETCH_INFINITE_MY_QUIZZES_SUCCESS](state, { myQuizzes, total }) {
    Vue.set(state, 'isLoadingMyQuizzes', false);
    Vue.set(state, 'total', total);
    Vue.set(state, 'myQuizzes', concat(state.myQuizzes, myQuizzes));
  },

  [types.FETCH_MY_QUIZZES_FAILURE](state, err) {
    Vue.set(state, 'isLoadingMyQuizzes', false);
    Vue.set(state, 'error', err);
  },

  [types.SET_QUIZ_REQUEST](state) {
    Vue.set(state, 'isLoadingQuiz', true);
  },

  [types.SET_QUIZ_SUCCESS](state, quiz) {
    Vue.set(state, 'isLoadingQuiz', false);
    Vue.set(state, 'myQuizzes', [
      quiz,
      ...state.myQuizzes,
    ]);
    Vue.set(state, 'quiz', quiz);
  },

  [types.SET_QUIZ_FAILURE](state, err) {
    Vue.set(state, 'isLoadingQuiz', false);
    Vue.set(state, 'error', err);
  },

  [types.PUT_QUIZ_REQUEST](state) {
    Vue.set(state, 'isLoadingQuiz', true);
  },

  [types.PUT_QUIZ_SUCCESS](state, quiz) {
    Vue.set(state, 'isLoadingQuiz', false);
    const myQuizzes = map(state.myQuizzes, (item) => {
      if (item.id === quiz.id) {
        return quiz;
      }

      return item;
    });

    Vue.set(state, 'myQuizzes', myQuizzes);
  },

  [types.PUT_QUIZ_FAILURE](state, err) {
    Vue.set(state, 'isLoadingQuiz', false);
    Vue.set(state, 'error', err);
  },

  [types.DELETE_QUIZ_REQUEST](state) {
    Vue.set(state, 'isLoadingQuiz', true);
  },

  [types.DELETE_QUIZ_SUCCESS](state, id) {
    Vue.set(state, 'isLoadingQuiz', false);
    const myQuizzes = filter(state.myQuizzes, item => item.id !== id);
    Vue.set(state, 'myQuizzes', myQuizzes);
    Vue.set(state, 'total', state.total - 1);
  },

  [types.DELETE_QUIZ_FAILURE](state, err) {
    Vue.set(state, 'isLoadingQuiz', false);
    Vue.set(state, 'error', err);
  },

};

export default mutations;



// WEBPACK FOOTER //
// ./src/app/my-quizzes/store/mutations.js